import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import { toast } from "sonner";

/**
 * Hook to delete a pending or rejected expense.
 * The server removes the receipt files along with the expense.
 * Invalidates the expense queries on success.
 */
export function useDeleteExpense() {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...trpc.expense.deleteExpense.mutationOptions(),
    onSuccess: () => {
      // Invalidate expense queries to refetch
      queryClient.invalidateQueries({
        queryKey: trpc.expense.getMyExpenses.queryKey(),
      });
      // Also invalidate org pending expenses view
      queryClient.invalidateQueries({
        queryKey: trpc.expense.getPendingExpensesForOrg.queryKey(),
      });
      toast.success("Expense deleted successfully");
    },
    onError: (error) => {
      toast.error(error.message || "Failed to delete expense");
    },
  });

  return mutation;
}
